import React from "react";

export default function CheckoutSkeleton() {
  return (
    <div className="min-h-screen bg-[#f8f9ff] flex items-center justify-center p-4 antialiased animate-pulse">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg border border-gray-100 p-6 sm:p-8">
        <div className="mb-6 pb-4 border-b border-gray-100 space-y-4">
          <div className="space-y-1.5">
            <div className="h-3 bg-gray-200 rounded w-16"></div>
            <div className="h-5 bg-gray-200 rounded w-48"></div>
          </div>

          <div className="space-y-1.5">
            <div className="h-3 bg-gray-200 rounded w-24"></div>
            <div className="h-5 bg-gray-200 rounded w-56"></div>
          </div>
        </div>

        <div className="mb-6 space-y-4">
          <div className="flex justify-between items-center">
            <div className="h-4 bg-gray-200 rounded w-24"></div>
            <div className="h-4 bg-gray-200 rounded w-36"></div>
          </div>

          <div className="flex justify-between items-center">
            <div className="h-4 bg-gray-200 rounded w-28"></div>
            <div className="h-4 bg-gray-200 rounded w-20"></div>
          </div>

          <div className="pl-4 border-l-2 border-gray-200 my-2 space-y-2">
            <div className="flex justify-between items-center">
              <div className="h-3 bg-gray-200 rounded w-32"></div>
              <div className="h-3 bg-gray-200 rounded w-16"></div>
            </div>

            <div className="flex justify-between items-center">
              <div className="h-3 bg-gray-200 rounded w-28"></div>
              <div className="h-3 bg-gray-200 rounded w-16"></div>
            </div>
          </div>

          <div className="h-[1px] bg-gray-100 my-3" />

          <div className="flex justify-between items-center">
            <div className="h-6 bg-gray-200 rounded w-32"></div>
            <div className="h-7 bg-gray-200 rounded w-28"></div>
          </div>
        </div>

        <div className="w-full mt-6 space-y-3">
          <div className="h-14 bg-gray-200 rounded-xl w-full"></div>
          <div className="h-6 bg-gray-200 rounded-lg w-20 mx-auto"></div>
        </div>
      </div>
    </div>
  );
}
